<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>
    <div
      style="float:left;margin-left:1em;"
    >
      <template>
<!--        <el-popover-->
<!--            placement="bottom"-->
<!--            trigger="click"-->
<!--          >-->
<!--            <template>-->
<!--              <div-->
<!--                v-for="site in filterSites"-->
<!--                :key="site.id"-->
<!--                class="site-selector"-->
<!--              >-->
<!--                <el-checkbox v-model="query.siteIds" :label="site.id">{{site.name}}</el-checkbox>-->
<!--              </div>-->
<!--            </template>-->
<!--            <template #reference>-->
<!--              <el-button size="small">选择站房</el-button>-->
<!--            </template>-->
<!--          </el-popover>-->
        <site-query :sites="filterSites" :query="query" />

          <el-button
            :disabled="!query.siteIds.length"
            type="orange"
            size="small"
            style="margin-left:10px;"
            @click="getData"
          >查询</el-button>
      </template>
    </div>
  </template>

  <template #toolbar>
    <!--<h3 style="margin: 0;">
      倒计时：
      <span style="display: inline-block;background: RGBA(44, 228, 139, 0.8);padding: 0.5px;border-radius: 5px;">{{now}}</span>
    </h3>-->
    <section class="time-wrapper">
      <div class="current-time">{{currentTime}}</div>
      <div class="countdown">{{countdown}}</div>
    </section>
  </template>

  <template #body>
    <data-wrapper>
      <el-table :data="dataList" height="100%" ref="dataTable">
        <el-table-column align="center" v-for="(item, index) in headerColumns" :key="index" :label="`${item.name}`" :class-name="`${index % 2 === 0 ? 'even-num-tr' : 'odd-num-tr'}`" >
          <!-- :class-name="`${index % 2 === 0 ? 'even-num-tr' : 'odd-num-tr'}`" -->
          <el-table-column :prop="`${item.id}DeviceName`" label="站点设备" width="180" align="center" :class-name="`${index % 2 === 0 ? 'even-num-tr' : 'odd-num-tr'}`" />
          <el-table-column
            :prop="`${item.id}Status`"
            label="当前状态"
            width="100"
            align="center"
            :class-name="`${index % 2 === 0 ? 'even-num-tr' : 'odd-num-tr'}`"
          >
            <!-- :class-name="`${index % 2 === 0 ? 'even-num-tr' : 'odd-num-tr'}`" -->
            <template v-slot="{row}">
              <span class="flag" :flag="row[`${item.id}Status`]">{{row[`${item.id}Status`]}}</span>
            </template>
          </el-table-column>
          <!-- :class-name="`${index % 2 === 0 ? 'even-num-tr' : 'odd-num-tr'}`"  -->
          <el-table-column :prop="`${item.id}HistoryStatus`" label="历史状态" width="270" align="center" :class-name="`${index % 2 === 0 ? 'even-num-tr' : 'odd-num-tr'}`" >
            <template slot="header" slot-scope="scope">历史状态<span v-if="dataList.length > 0"><br />{{min}} - {{max}}</span></template>

            <template v-slot="{row}">
              <p>
              <span
                v-for="(el, elIndex) in row[`${item.id}HistoryStatus`]"
                :key="elIndex"
                class="historycell"
                :historycell="el.status"
                :title="el.time"
              ></span>
              </p>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteData from '../../BaseSiteData'
import DataWrapper from '../../../components/Data/DataWrapper'
import SiteQuery from '../../../components/Data/Query/SiteQuery'

export default {
  name: 'OperationsSiteDeviceStatus',
  routeInfo: {
    label: '站房状态和仪器',
    icon: 'fa fa-users'
  },
  extends: BaseSiteData,
  components: {SiteQuery, DataWrapper},
  data () {
    return {
      now: '08:00',
      maxTime: 8 * 60,
      step: 1,
      timer: null,
      dataTableKey: new Date().getTime(),
      headerColumns: [],
      dataList: [],
      currentTime: '',
      countdown: '',
      min: null,
      max: null
    }
  },
  computed: {
  },
  methods: {
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length > 0) {
        let {query: {siteIds}} = this

        if (siteIds.length === 0) {
          siteIds.push(...filterSites.slice(0, this.minSiteSelectNumber).map(site => site.id))
        }
      }

      this.afterSetSiteIds()
    },
    afterSetSiteIds () {
      this.setCurrentQuery()
      this.updateTimeTimer()
      this.getData()
    },
    updateTimeTimer () {
      const MINUTE_STEP = 10
      let now = new Date()
      this.currentTime = now.format('YYYY年MM月DD日HH:mm:ss')
      let nowTS = now.getTime()
      let currentMinutes = now.getMinutes()
      now.setMinutes(currentMinutes + (MINUTE_STEP - (currentMinutes % MINUTE_STEP)), 0, 0)
      let minuteDiff = Math.round((now.getTime() - nowTS) / 1000)
      // minuteDiff = minuteDiff === 60 ? 0 : minuteDiff

      let minutes = (minuteDiff / 60) | 0
      let seconds = minuteDiff % 60
      this.countdown = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      this.timeTimer = setTimeout(this.updateTimeTimer, 1000 - (nowTS % 1000))

      if (minuteDiff <= 1) {
        this.getData()
      }
    },
    clearCalcTimeTimer () {
      clearTimeout(this.timeTimer)
    },
    getData () {
      if (this.query.siteIds.length === 0) return
      this.changeLoadStatus(true)
      this.maxTime = 8 * 60
      let query = {
        siteIds: this.query.siteIds
      }

      this.$api.Device.getSiteState(query).then(backData => {
        if (backData.length === 0) {
          this.dataList = []
          return false
        }

        this.setTableColumns()
        this.formatData(backData)
        this.$nextTick(() => {
          this.$refs['dataTable'].doLayout()
        })
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setTableColumns () {
      let {query: {siteIds}, filterSiteMap} = this
      let headerColumns = []

      let currentQuerySiteMap = siteIds.map(siteId => filterSiteMap[siteId])

      currentQuerySiteMap.forEach(item => {
        headerColumns.push({
          id: item.id,
          name: item.name,
          width: 90,
          align: 'center'
        })
      })

      this.headerColumns = headerColumns
    },
    formatData (dataList) {
      let {deviceStatus, statusData} = dataList
      let level = {
        0: '通讯中断',
        1: '正常',
        2: '停用'
      }

      let siteDataMap = statusData.reduce((map, el) => {
        if (!map[el.siteId]) {
          map[el.siteId] = []
        }

        map[el.siteId].push(el)
        return map
      }, {})

      let temp = {}
      let length = 0
      let dataTemp = []
      for (let key in siteDataMap) {
        let deviceNames = Array.from(new Set(siteDataMap[key].map(item => {
          return item.deviceName
        })))

        let deviceDataMap = deviceNames.reduce((map, device) => {
          if (!map[device]) {
            map[device] = {}
          }

          map[device][`${key}Status`] = '无设备'
          map[device][`${key}HistoryStatus`] = []

          return map
        }, {})

        let min = new Date().getTime()
        let max = min - 23 * 1000 * 60 * 60

        siteDataMap[key].forEach(item => {
          let {deviceName, siteId, siteDeviceId, status, dataTime} = item

          if (!deviceDataMap[deviceName].dataTime) {
            deviceDataMap[deviceName].dataTime = dataTime
          }

          let date = new Date(dataTime)
          let ts = date.getTime()

          if (ts < min) {
            min = ts
          } else if (ts > max) {
            max = ts
          }

          if (new Date(deviceDataMap[deviceName].dataTime).getTime() < ts) {
            deviceDataMap[deviceName].dataTime = dataTime
          }

          deviceDataMap[deviceName][siteId + 'Status'] = level[deviceStatus[siteDeviceId]]
          deviceDataMap[deviceName][siteId + 'DeviceName'] = item.deviceName

          if (deviceDataMap[deviceName][siteId + 'Status'] && deviceDataMap[deviceName][siteId + 'HistoryStatus']) {
            deviceDataMap[deviceName][siteId + 'HistoryStatus'].push({
              status: status,
              time: date.format('MM-DD HH时')
            })
          }
        })

        min = new Date(min).format('YYYY-MM-DD HH时')
        max = new Date(max).format('YYYY-MM-DD HH时')
        this.min = min
        this.max = max

        if (Object.values(deviceDataMap).length > length) {
          length = Object.values(deviceDataMap).length
        }

        temp[key] = Object.values(deviceDataMap)
      }

      for (let i = 0; i < length; i++) {
        for (let key in temp) {
          if (!dataTemp[i]) {
            dataTemp[i] = {}
          }
          dataTemp[i] = Object.assign(dataTemp[i], temp[key][i] ? temp[key][i] : {})
        }
      }

      this.dataList = dataTemp
    },
    tempFun (dataList) {
      let {query: {siteIds}} = this
      let {deviceStatus, statusData} = dataList
      let deviceNames = Array.from(new Set(statusData.map(item => {
        return item.deviceName
      })))

      let deviceDataMap = deviceNames.reduce((map, device) => {
        if (!map[device]) {
          map[device] = {
            deviceName: device
          }
        }

        for (let i = 0; i < siteIds.length; i++) {
          map[device][`${siteIds[i]}Status`] = '无设备'
          map[device][`${siteIds[i]}HistoryStatus`] = []
        }

        return map
      }, {})

      let level = {
        0: '通讯中断',
        1: '正常',
        2: '停用'
      }

      let min = new Date().getTime()
      let max = min - 23 * 1000 * 60 * 60

      statusData.forEach(item => {
        let {deviceName, siteId, siteDeviceId, status, dataTime} = item

        if (!deviceDataMap[deviceName].dataTime) {
          deviceDataMap[deviceName].dataTime = dataTime
        }

        let date = new Date(dataTime)
        let ts = date.getTime()

        if (ts < min) {
          min = ts
        } else if (ts > max) {
          max = ts
        }

        if (new Date(deviceDataMap[deviceName].dataTime).getTime() < ts) {
          deviceDataMap[deviceName].dataTime = dataTime
        }

        deviceDataMap[deviceName][siteId + 'Status'] = level[deviceStatus[siteDeviceId]]

        if (deviceDataMap[deviceName][siteId + 'Status'] && deviceDataMap[deviceName][siteId + 'HistoryStatus']) {
          deviceDataMap[deviceName][siteId + 'HistoryStatus'].push({
            status: status,
            time: date.format('MM-DD HH时')
          })
        }
      })

      min = new Date(min).format('YYYY-MM-DD HH时')
      max = new Date(max).format('YYYY-MM-DD HH时')
      this.min = min
      this.max = max
      this.dataList = Object.values(deviceDataMap)
    }
  },
  beforeDestroy () {
    this.clearCalcTimeTimer()
  }
}
</script>

<style lang="scss" scoped>
.el-table /deep/ td {
  padding: 2px 0 !important;
}
.cell > p {
  margin: 0;
  padding: 0;
  line-height: 10px;
}
.time-wrapper {
  > * {
    float: left;
  }

  > .current-time {
    line-height: 32px;
  }

  > .countdown {
    margin-left: 1rem;
    padding: 0 30px;
    line-height: 30px;
    border: 1px solid #DCDFE6 {
      radius: 16px;
    };
  }
}
.el-table /deep/ .gutter {
  display: none;
}
.flag {
  width: 100%;
  height: 100%;
  color: #FFFFFF;
  font-size: 16px;
  display: inline-block;
  padding: 5px;
  margin: 0;

  &[flag="通讯中断"] {
    background: #F56C6C;
  }

  &[flag="正常"] {
    background: #2ce460;
  }

  &[flag="停用"] {
    background: #eee93b;
    color: #212322;
  }

  &[flag="无设备"] {
    background: #909399;
  }
}

.historycell {
  width: 10px;
  height: 20px;
  display: inline-block;
  border: 1px solid #212322;

  &[historycell="0"] {
    background: #FFFFFF;
  }

  &[historycell="1"] {
    background: #2ce460;
  }

  &[historycell="2"] {
    background: #FFFFFF;
  }
}
.el-table /deep/ .even-num-tr {
  background: RGBA(255, 255, 255, 0.5);
  color: #212322;
}
.el-table /deep/ .odd-num-tr {
  // background: RGBA(153, 255, 255, 0.5);
  background: RGBA(249, 249, 249, 1);
  color: #212322;
}
</style>



// WEBPACK FOOTER //
// src/views/08Operations/01Site-Device/index.vue